import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { cn } from '../../lib/cn';

export interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  /** Renders a back link above the title — the main way out on a phone. */
  backTo?: string;
  backLabel?: string;
  className?: string;
}

export function PageHeader({
  title,
  subtitle,
  actions,
  backTo,
  backLabel = 'Назад',
  className,
}: PageHeaderProps) {
  return (
    <header className={cn('flex flex-col gap-3', className)}>
      {backTo ? (
        <Link
          to={backTo}
          className="inline-flex min-h-11 w-fit items-center gap-1.5 text-sm font-medium text-ink-muted hover:text-ink"
        >
          <span aria-hidden="true">←</span>
          {backLabel}
        </Link>
      ) : null}

      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-xl font-bold tracking-tight break-words text-ink sm:text-2xl">
            {title}
          </h1>
          {subtitle ? (
            <p className="mt-1 text-sm break-words text-ink-muted">{subtitle}</p>
          ) : null}
        </div>
        {actions ? (
          <div className="flex w-full shrink-0 flex-wrap gap-2 sm:w-auto">{actions}</div>
        ) : null}
      </div>
    </header>
  );
}
